import { render, staticRenderFns } from "./issues-add.vue?vue&type=template&id=5729f6aa&scoped=true&"
import script from "./issues-add.vue?vue&type=script&lang=js&"
export * from "./issues-add.vue?vue&type=script&lang=js&"
import style0 from "./issues-add.vue?vue&type=style&index=0&lang=css&"
import style1 from "./issues-add.vue?vue&type=style&index=1&id=5729f6aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5729f6aa",
  null
  
)

export default component.exports